<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <div *ngIf="!showAvatar || !user.avatar"
            class="flex rounded-full bg-black text-white w-8 h-8 justify-center items-center dark:text-white dark:bg-black">
            <span class="text-sm font-semibold">{{ storeInitials | uppercase }}</span>
        </div>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    class="w-64 rounded-xl"
    #userActions="matMenu">
    <button mat-menu-item class="cursor-default">
        <span class="flex flex-col leading-none">
            <span class="my-1.5 text-md font-medium">{{user.email}}</span>
            <span class="text-sm text-secondary">{{user.role}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>

    <!-- User personal paywall status -->
    <div class="px-4 py-3" (click)="$event.stopPropagation()">
        <ng-container *ngIf="subscription$ | async as sub">
            <div *ngIf="sub.creditBalance" class="flex items-center justify-between mb-3">
                <span class="text-sm text-secondary">Créditos</span>
                <span class="text-sm font-semibold"
                      [ngClass]="{'text-warn': sub.creditBalance.available <= 0}">
                    {{ sub.creditBalance.available }}
                </span>
            </div>
        </ng-container>

        <ng-container *ngIf="quotaEntitlements$ | async as quotas">
            <div *ngFor="let e of quotas" class="mb-3 last:mb-0">
                <div class="flex items-center justify-between mb-1">
                    <span class="text-sm font-medium">{{ e.feature_name }}</span>
                    <span class="text-sm text-secondary">{{ e.quota_used || 0 }} / {{ e.quota_limit }}</span>
                </div>
                <mat-progress-bar
                    mode="determinate"
                    [value]="quotaPercent(e)"
                    [color]="quotaPercent(e) >= 100 ? 'warn' : 'primary'">
                </mat-progress-bar>
            </div>
        </ng-container>
    </div>
    <mat-divider class="my-2"></mat-divider>

    <a [routerLink]="['/paywall']" routerLinkActive="router-link-active" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:sparkles'"></mat-icon>
        <span>Meu plano</span>
    </a>
    <a [routerLink]="['/minhaconta']" routerLinkActive="router-link-active" mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Minha Conta</span>
    </a>
    <button mat-menu-item *hasRole="'superadmin'">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Configurações</span>
    </button>
    <mat-divider class="my-2" *hasRole="'superadmin'"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sair</span>
    </button>
</mat-menu>
